import React from 'react';
import { Calendar, CheckSquare } from 'lucide-react';

/**
 * Секция дополнительных параметров расчета, включая авансовые платежи
 */
const AdditionalParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors,
  advancePaymentMethods
}) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <CheckSquare className="w-5 h-5 mr-2 text-indigo-500" />
        Дополнительные параметры
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Блок авансовых платежей */}
        <div className="col-span-full">
          <div className="flex items-center mb-2">
            <input
              type="checkbox"
              id="advancePayments"
              name="advancePayments"
              checked={formData.advancePayments}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <label htmlFor="advancePayments" className="ml-2 text-sm font-medium text-gray-700 dark:text-gray-300 flex items-center">
              <Calendar className="w-4 h-4 mr-1 text-indigo-500" />
              Рассчитать авансовые платежи
            </label>
          </div>
          
          {formData.advancePayments && (
            <div className="mt-3 pl-6">
              <label htmlFor="advancePaymentMethod" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Метод расчета авансовых платежей
              </label>
              <select
                id="advancePaymentMethod"
                name="advancePaymentMethod"
                value={formData.advancePaymentMethod}
                onChange={handleInputChange}
                className={`form-select w-full ${errors.advancePaymentMethod ? 'input-error' : ''}`}
              >
                {advancePaymentMethods.map((method) => (
                  <option key={method.id} value={method.id}>
                    {method.name}
                  </option>
                ))}
              </select>
              
              {/* Показываем описание выбранного метода */}
              {formData.advancePaymentMethod && (
                <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
                  {advancePaymentMethods.find(m => m.id === formData.advancePaymentMethod)?.description || ''}
                </p>
              )}
            </div>
          )}
        </div>
        
        {/* Блок специальных вычетов и льгот */}
        <div className="col-span-full">
          <div className="flex items-center mb-2">
            <input
              type="checkbox"
              id="specialDeductions"
              name="specialDeductions"
              checked={formData.specialDeductions}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <label htmlFor="specialDeductions" className="ml-2 text-sm font-medium text-gray-700 dark:text-gray-300">
              Использовать специальные вычеты и льготы
            </label>
          </div>
        </div>
        
        {/* Блок дивидендов */}
        <div className="col-span-full">
          <div className="flex items-center mb-2">
            <input
              type="checkbox"
              id="dividends"
              name="dividends"
              checked={formData.dividends}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <label htmlFor="dividends" className="ml-2 text-sm font-medium text-gray-700 dark:text-gray-300">
              Учитывать доходы и расходы в виде дивидендов
            </label>
          </div>
        </div>
      </div>
      
      {/* Информационный блок */}
      <div className="mt-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg p-3">
        <div className="flex items-start">
          <Calendar className="w-5 h-5 text-blue-600 dark:text-blue-400 mr-2 mt-0.5" />
          <div>
            <h4 className="text-sm font-medium text-blue-700 dark:text-blue-300 mb-1">
              Об авансовых платежах по налогу на прибыль
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400">
              Организации обязаны исчислять и уплачивать авансовые платежи по налогу на прибыль. В зависимости от размера выручки и других факторов, платежи могут быть ежеквартальными или ежемесячными. Крупнейшие налогоплательщики обязаны уплачивать ежемесячные авансовые платежи исходя из фактической прибыли. Срок уплаты авансовых платежей - не позднее 28 числа месяца, следующего за отчетным периодом.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdditionalParametersSection;